import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class OnCallTypeDto extends BaseEntityDto {
  name: string;
  excludesWorkableMissingHours: boolean;
  isWorkableOnSaturday: boolean;
}
